export default {
  order: '序号',
  testCaseCode: '用例编号',
  testProductVersion: '产品版本',
  testCaseScene: '用例场景',
  featureName: '功能/外设/软件',
  featureType: '功能类型',
  testCaseName: '用例名称',
  testCaseType: '用例类型',
  testCaseCategory: '用例来源',
  testCaseContent: '用例内容',
  testCaseStep: '用例步骤',
  testUserDemand: '用户诉求',
  testCaseExpectedResult: '预期结果',
  remarks: '备注',
  valueDesc: '价值',
  operation: '操作',
  addTestCase: {
    feature: '补充功能用例',
    peripheral: '补充外设用例',
    software: '补充软件用例',
    def: '补充用例'
  },
  tips: { remarks: '注意事项或限制说明' },
  searchPlaceholder: {
    testCaseName: '请输入用例名称'
  }
}
